import { atom } from 'jotai'
import { QueryClient } from '@tanstack/react-query'

export const isMutedAtom = atom(true);
export const isLoadedDirectDoneAtom = atom(false);
export const activeTabAtom = atom("home");
export const personalRefCodeAtom = atom(0);
export const watchingPageAtom = atom(0);
export const queryClient = new QueryClient()
export const selectedLangAtom = atom("EN");


export const TapStates = {
    NORMAL: 0,
    INTERRACTION: 1,
    SKIP: 2,
    LIKE: 3,
    TAP_INITIATED: 4,
    MOVE_INITIATED: 5,
    PAUSED: 6,
  };
  
class TapController extends EventTarget {
    constructor() {
        super();
        this.time = 0;
        // this.pressed = false;
        this.muteTrigger = 200;
        this.playbackTrigger = 300;
        this.timerId = null;
        this.start_x = null;
        this.end_x = null;
        this.state = TapStates.NORMAL;
    }
    pressStart(startX) {

        if (this.state === TapStates.PAUSED) {
        this.dispatchEvent(new CustomEvent("play"));
        this.dispatchEvent(new CustomEvent("stopInterraction"));
        }

        this.state = TapStates.TAP_INITIATED;
        this.start_x = startX;
        this.time = +new Date();
        this.timerId = setTimeout(this.dispatchPause.bind(this), this.playbackTrigger);
    }
    dispatchPause() {
        if (this.state === TapStates.TAP_INITIATED) {
        this.state = TapStates.PAUSED;
        this.dispatchEvent(new CustomEvent("pause"));
        this.dispatchEvent(new CustomEvent("interracted"));
        }
    }
    cancel(posX) {

        if (this.state === TapStates.NORMAL) {
        return;
        }

        this.end_x = posX;

        if (this.state === TapStates.TAP_INITIATED) {
            this.state = TapStates.MOVE_INITIATED;
            clearTimeout(this.timerId);
        }

        let delta_pos_x_px = this.start_x - this.end_x;
        let delta_pos_x = 2 * delta_pos_x_px / document.body.clientWidth;


        if (this.state === TapStates.PAUSED) {
        if (Math.abs(delta_pos_x) > 3) {
            this.state = TapStates.INTERRACTION;
        }
        return;
        }


        if (this.state === TapStates.MOVE_INITIATED) {
        if (Math.abs(delta_pos_x_px) > 0) {
            this.state = TapStates.INTERRACTION;
            this.dispatchEvent(new CustomEvent("interracted"));
            this.dispatchEvent(new CustomEvent("pause"));
        }
        }

        if (this.state === TapStates.INTERRACTION) {
            if (delta_pos_x < -0.7) {
                this.dispatchEvent(new CustomEvent("like"));
                this.dispatchEvent(new CustomEvent("stopInterraction"));
                this.state = TapStates.NORMAL;
            }
            if (delta_pos_x > 0.7) {
                this.dispatchEvent(new CustomEvent("skip"));
                this.dispatchEvent(new CustomEvent("stopInterraction"));
                this.state = TapStates.NORMAL;
            }
            this.dispatchEvent(new CustomEvent("changeX", { detail: {delta_x: delta_pos_x_px}}));
        }

    }

    pressEnd() {

        this.start_x = null;
        this.end_x = null;

        const delta = +new Date() - this.time;

        if (this.state === TapStates.TAP_INITIATED) {
        if (delta < this.muteTrigger) {
            this.dispatchEvent(new CustomEvent("mute"));
        }
        }

        if (this.state === TapStates.PAUSED) {
            this.dispatchEvent(new CustomEvent("play"));
            this.dispatchEvent(new CustomEvent("stopInterraction"));
        }

        if (this.state === TapStates.INTERRACTION) {
            this.dispatchEvent(new CustomEvent("play"));
            this.dispatchEvent(new CustomEvent("stopInterraction"));
        }

        this.state = TapStates.NORMAL;

    }
}
  
export const eventTragetControl = new TapController();
  